import { React, useState }  from "react";
import "./CreateShelfModal.css";
import axios from 'axios';
import { API_BASE_URL } from "../../Variables";

import xIcon from "../../assets/images/x-icon.svg";

function CreateShelfModal( {setDisplayCreateModal, refreshShelves} ) {

  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();  // Prevent form submission and page reload
    const shelfName = document.getElementById('shelf-name').value;

    if (!shelfName) {
      setError('Please enter a shelf name');
      return;
    }

    const token = localStorage.getItem('token');

    // Add the new shelf to the database
    try {
      await axios.post(`${API_BASE_URL}/shelves`, {
        name: shelfName
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Close modal only if successful and refresh shelves
      refreshShelves();
      setDisplayCreateModal(false);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error); 
      } else {
        setError('Failed to create shelf'); 
      }
    }
  };


  return (
  <div className="create-shelf-overlay">
    <div className="create-shelf-modal">
      <div className="modal-header">
        <img src={xIcon} alt="Close" onClick={() => setDisplayCreateModal(false)} className="modal-close"/>
      </div>
      <form onSubmit={handleSubmit}>
        <input type="text" id="shelf-name" name="shelf-name" placeholder="New Shelf Name" className="modal-input"/>
        <button type="submit" className="tertiary-button">Create Shelf</button>
        {error && <p className="error">{error}</p>}
      </form> 
    </div>
  </div>
);
}

export default CreateShelfModal;
